module.exports = __webpack_public_path__ + "img/pz.a7214d3e.png";